import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarComponent } from "./snackbar/snackbar.component";

@Injectable()
export class SnackbarService {
	constructor(private snackBar: MatSnackBar) { }

	show({
		status = "success",
		titlePlaceholder = "",
		messagePlaceholder = ""
	}: {
		status?: "success" | "info" | "error";
		titlePlaceholder?: string;
		messagePlaceholder?: string;
	} = {}, duration = 5e3) {
		this.snackBar.openFromComponent(SnackBarComponent, {
			duration,
			// panelClass: success ? 'snackbar-success' : 'snackbar-error'
			data: { status, titlePlaceholder, messagePlaceholder }
		});
	}
}